<template>
    <div>
        <app-erros-box
            :erros="erros"
            v-if="erros.length > 0 && mostrarDespesa"
        ></app-erros-box>
        <despesa
            v-if="mostrarDespesa"
            :despesa="despesa"
            :temAcessoDetalharItem="$temAcessoView('DESP-GERAIS-FINAL-00')"
            :rotaDetalharItem="
                'DespesasGerais_Finalizacao_ItensDespesa_Detalhar'
            "
            :rotaAtualizacaoEmMassa="
                'DespesasGerais_Finalizacao_Despesas_AtualizarRateiosEmMassa'
            "
            :temAcessoAnexos="$temAcessoView('DESP-GERAIS-FINAL-00')"
            :temAcessoHistorico="$temAcessoView('DESP-GERAIS-FINAL-00')"
            :mostrarAnexos="mostrarAnexos"
            :anexos="anexos"
            :servicos="obterServicos()"
            @mostrarAnexos="obterAnexos()"
            @baixarAnexo="baixarAnexo($event)"
            @fecharAnexos="fecharAnexos()"
            @obterAtualizacao="obterDespesa()"
            @obterDespesa="obterDespesa()"
            @obterUnidades="obterUnidades()"
            @obterAcoes="obterAcoes($event)"
            @obterProjetos="obterProjetos($event)"
            :unidades="unidades"
            :projetos="projetos"
            :acoes="acoes"
            @salvarRateios="salvarRateiosEmMassa($event)"
        >
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
                <btn-reprovar
                    :despesa="despesa"
                    @obterDespesa="obterDespesa()"
                ></btn-reprovar>
                <btn-comprometer
                    :despesa="despesa"
                    @obterDespesa="obterDespesa()"
                    @exibirErro="exibirErroSaldo($event)"
                ></btn-comprometer>
            </template>
        </despesa>
        <router-view></router-view>
    </div>
</template>

<script>
import Despesa from '@/app/despesasgerais/componentes/despesas/Despesa.vue'
import DespesasServicos from './DespesasServicos'
import DespesasAnexosServicos from './DespesasAnexosServicos'
import BtnComprometer from './BtnComprometer.vue'
import BtnReprovar from './BtnReprovar.vue'
import RateiosServicos from '../rateios/RateiosServicos'

export default {
    data() {
        return {
            despesa: null,
            mostrarAnexos: false,
            anexos: [],
            unidades: [],
            projetos: [],
            acoes: [],
            erros: []
        }
    },

    components: {
        Despesa,
        BtnComprometer,
        BtnReprovar
    },

    methods: {
        obterDespesa() {
            this.$store.dispatch('addRequest')
            DespesasServicos.obterPorId(this.$route.params.despesaId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.despesa = response.data
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterAnexos() {
            this.$store.dispatch('addRequest')
            DespesasAnexosServicos.obterAnexos(
                this.$route.params.despesaId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.anexos = response.data
                        this.mostrarAnexos = true
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        baixarAnexo(anexo) {
            DespesasAnexosServicos.baixarAnexo(anexo).then(response => {
                if (response) {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao realizar download do anexo!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(response, anexo.nomeArquivoOriginal)
                        }
                    }
                }
            })
        },

        fecharAnexos() {
            this.mostrarAnexos = false
        },

        obterServicos() {
            return DespesasServicos
        },

        obterUnidades() {
            this.$store.dispatch('addRequest')
            RateiosServicos.obterUnidades().then(response => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterProjetos(evento) {
            this.$store.dispatch('addRequest')
            RateiosServicos.obterProjetos(evento.codUnidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.projetos = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAcoes(evento) {
            this.$store.dispatch('addRequest')
            RateiosServicos.obterAcoes(
                evento.codUnidade,
                evento.codProjeto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.acoes = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        salvarRateiosEmMassa(rateiosDto) {
            this.$store.dispatch('addRequest')
            RateiosServicos.salvarRateiosEmMassa(rateiosDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Rateios atualizados com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterDespesa()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        exibirErroSaldo(erroSaldo) {
            this.erros = erroSaldo.split(';')
        }
    },

    created() {
        this.obterDespesa()
    },

    watch: {
        $route(to) {
            if (this.$store.getters.recarregar) {
                this.obterDespesa()
                this.$store.dispatch('setRecarregar', false)
            }
        }
    },

    computed: {
        mostrarDespesa() {
            return (
                this.$route.name ===
                'DespesasGerais_Finalizacao_Despesas_Detalhar'
            )
        }
    }
}
</script>
